import { useInfiniteQuery } from "@tanstack/react-query";
import { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import debounce from "lodash.debounce";
import { fetchJvBankAccountByClient, fetchJvPaymentsByClientId, fetchReadJvBroker } from "../../utils/apiUtils";
import SharedTable from "../benefitPlan/SharedTable";
import Select from 'react-select';

const searchEntryTypeOptions = [
    { label: 'O', value: 'O' },
    { label: 'C', value: 'C' },
    { label: 'X', value: 'X' },
    { label: 'Z', value: 'Z' }
]

const Payments = () => {

    const [searchValue, setSearchValue] = useState();
    const [decouncedSearchValue, setDecouncedSearchValue] = useState();
    const [selectedEntryTypeSearchOption, setSelectedEntryTypeSearchOption] = useState(null);

    const { ref, inView } = useInView();

    const { data, error, fetchNextPage, hasNextPage, isLoading, isPending, isFetching, isFetchingNextPage, status, refetch } = useInfiniteQuery({
        queryKey: ["jv-payments", decouncedSearchValue, selectedEntryTypeSearchOption],
        queryFn: async ({ pageParam }) => {
            let params = pageParam || {};

            if (decouncedSearchValue) {
                params.clientId = decouncedSearchValue
            }

            if (selectedEntryTypeSearchOption?.value) {
                params.entryType = selectedEntryTypeSearchOption?.value
            }
            return await fetchJvPaymentsByClientId({ ...params });
        },

        select: (data) => {
            const flattenData = data.pages.flatMap((x) => x).filter(x => Object.keys(x)?.length)
            return {
                count: flattenData?.length,
                rows: flattenData

            };
        },
        initialPageParam: 0,
        getNextPageParam: (lastPage, pages) => {
            const hasMore = lastPage?.count !== 20

            if (!hasMore) return undefined;
            return { offset: pages.reduce((acc, curr) => acc + curr.length, 0) }
        },
        staleTime: 12 * 60 * 60 * 1000, //12 hours
        enabled: true,
    });

    useEffect(() => {
        if (inView) {
            fetchNextPage();
        }
    }, [inView]);

    const debouncedChangeHandler = useCallback(
        debounce((event) => {
            setDecouncedSearchValue(event.target.value?.trim());
        }, 500),
        []
    );

    const columns = ['clientid', 'blkofbusid', 'certificatenumber', 'checknumber', 'amount', 'entrytype', 'entrydate', 'note', 'chguser', 'chgts'];

    const onDetailHandler = async (body) => {

        const [bankAcctByClient, brokerInfo, bankDetailsResult] = await Promise.allSettled([
            fetchJvBankAccountByClient({ clientId: body.clientid }),
            fetchReadJvBroker({ code: body.clientid }),

        ])


        return {
            bankInfo: bankAcctByClient?.value?.[0],
            brokerInfo: brokerInfo?.value?.Response?.BrokerDemographic,
            bankDetails: bankDetailsResult?.Items?.[0]
        }
    }

    return (
        <div className={'container '}>
            <p className='title'>Payments</p>
            <p className="sub-title">JV payments</p>

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 1rem 1rem 0rem', }}>
                <div style={{ display: 'flex', gap: '1rem', alignItems: 'center', width: '100%', flexWrap: 'wrap', }}>



                    <input
                        style={{ fontSize: "1rem", minWidth: "250px", padding: "1rem", borderRadius: ".4rem", border: "1px solid var(--lighterGrey)", outline: "none" }}
                        type="text"
                        id={"search"}
                        placeholder="Client Id..."
                        // list="items"
                        autoComplete="off"
                        // onFocus={() => setCurrentPage(0)}
                        onChange={(e) => {
                            setSearchValue(e.target.value);
                            debouncedChangeHandler(e);
                        }}
                        value={searchValue}
                    />

                    <Select
                        name={'searchOptions'}
                        placeholder="Entry type"
                        className="react-select-container large-input"
                        classNamePrefix="react-select"
                        options={searchEntryTypeOptions}
                        value={selectedEntryTypeSearchOption}
                        onChange={(option) => { setSelectedEntryTypeSearchOption(option) }}
                    />

                </div>
            </div>

            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0rem 1rem 1rem 0rem", }}>
                <p
                    style={{ cursor: "pointer", color: "var(--red)" }}
                    onClick={() => {
                        setSelectedEntryTypeSearchOption()
                        setDecouncedSearchValue("");
                        setSearchValue("");
                    }}
                >
                    Clear filters
                </p>

            </div>


            {status === "loading" ? (
                <p>Loading...</p>
            ) : status === "error" ? (
                <span className='danger'>Error: {error.message}</span>
            ) : (
                <>
                    <SharedTable
                        type={"jv-payments"}
                        disableHeaderFormatting={true}
                        columns={columns}
                        items={data?.rows}
                        activeDraftId={null}
                        hasNextPage={hasNextPage}
                        isFetchingNextPage={isFetchingNextPage}
                        fetchNextPage={fetchNextPage}
                        isFetching={isFetching}
                        isLoading={isLoading}
                        // onEditHandler={onEditHandler}
                        onDetailHandler={onDetailHandler}
                        ref={ref}
                    />
                </>
            )}

        </div>
    )
}

export default Payments